import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";

const ModulePullRequestsTablePullRequestActionsCell = (
  props: TableSimpleCellProps<ModulePullRequestsTableRow>
) => {
  return (
    <TableSimpleCell {...props}>
      <TableCellEmpty />
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTablePullRequestActionsCell;
